export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5209.93f099e0.jpg";